import clsApi from '@cls/clsApi'

class clsEmployeeApi extends clsApi {


    loadTariff(id_employee, id_tariff) { 
        return this.post(`tariff/load`, {id_employee:id_employee, id_tariff: id_tariff}); 
    }
    
    saveTariff(model) { 
        return this.post(`tariff/save`, model); 
    }

    inviteUser(id_employee, email, name) { 
        return this.post(`invitation/send`, {id_employee: id_employee, email: email, name: name}); 
    }
    resendInvitation(id_employee) { 
        return this.post(`invitation/resend`, {id_employee: id_employee}); 
    }
    removeInvitation(id_employee) {
        return this.post(`invitation/remove`, {id_employee: id_employee}); 
    }
    removeUser(id_employee) {
        return this.post(`removeuser`, {id_employee: id_employee}); 
    }

}

export default clsEmployeeApi;
